module.exports = __webpack_public_path__ + "static/media/spin.86ea7ace.webp";